<template lang="pug">
	div
		loading(:active.sync="busy", :is-full-page="false")
		.card.card-custom.gutter-b
			.card-header
				.card-title
					.card-label Advertisers
				.card-toolbar
			.card-body
				form.form.form-inline.form-filters(@submit.prevent="loadData()", :class="{expanded:filtersExpanded}")
					a.btn.btn-primary.toggle-filters.d-md-none(v-b-toggle.form-filters)
						span Filters
						i.fa.fw.fa-chevron-up.transition-all(:class="{'rotate-180':filtersExpanded}")
					b-collapse#form-filters.dont-collapse-sm(style="width: 100%;", v-model="filtersExpanded")
						.row.filters-form-row
							.form-row-main.col-auto.mr-auto(style="flex:1;")
								.form-group
									label Search
									input.form-control.input-search(type="text", placeholder="Search...", v-model="filters.keyword", v-debounce:300ms="loadData")
								.form-group
									label Status
									select.form-control(v-model="filters.status", @change="loadData()")
										option(v-for="o in statusOptions", :value="o.v") {{ o.t }}
								.form-group.no-label
									button.btn.btn-primary(type="submit") Go
							.form-row-end.col-auto
								.form-group.no-label
									router-link.btn.btn-success(:to="{name:'advertiser-add'}")
										i.flaticon2-plus
										| Add

				p.clearfix &nbsp;

				table.table.table-bordered
					thead
						tr
							th ID
							th Active
							th Name
							th API
							th Last Fetch
							th Num. Offers
							th Secret
							th(style="width: 220px") Panel
							th Actions
					tbody
						tr(v-if="records.length===0")
							td(colspan="7") No matching records were found
						tr(v-for="r in records", :key="r.id")
							td {{ r.id }}
							td {{ r.active }}
							td {{ r.name }}
							td {{ r.fetch_api }}
							td.has-actions {{ r.api_last_sync }}
								a.cell-action(href="javascript:void(0)", @click="fetchApi(r)", v-b-tooltip.hover, title="Fetch now")
									i.la.la-refresh(:class="{'la-spin':r.api_processing}")
							td {{ r.num_offers }}
							td {{ r.secret }}
							td
								.input-group(v-if="r.panel_url")
									input.form-control.form-control-sm(type="text", :value="r.panel_username", readonly="readonly")
									input.form-control.form-control-sm(type="text", :value="r.panel_password", readonly="readonly")
									a.btn.btn-sm.btn-secondary(:href="r.panel_url", target="_blank")
										i.la.la-external-link
								//span(v-if="r.panel_url") {{ r.panel_username }} / {{ r.panel_password }}
								//	| &nbsp;
								//	a(:href="r.panel_url")
								//		i.la.la-external-link
							td.actions
								router-link.btn.btn-action.btn-secondary(:to="{name:'advertiser-edit', params: {id:r.id}}")
									i.la.la-pen
								.btn.btn-action.btn-outline-danger()
									i.la.la-trash

				paginate(:paginator="paginate", @update-page-size="loadData")

</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
export default {
	name: 'AdvertiserList',
	data(){
		return {
			busy: false,
			// PERMS: null,
			paginate: {
				numPages: 0,
				total: 0,
				page: 1,
				limit: 50,
				onPageChange: () => {
					this.loadData();
				}
			},
			filters: {
				keyword: '',
				status: 1
			},
			statusOptions: [
				{v: undefined, t: 'All'},
				{v: 0, t: 'Inactive'},
				{v: 1, t: 'Active Only'},
			],
			records: [],
			filtersExpanded: false,
		};
	},
	mounted() {
		this.$store.dispatch(SET_BREADCRUMB, [
			{ title: 'Media' },
			{ title: 'Advertisers' }
		]);
	},
	methods: {

		async fetchApi(r){
			if (r._busy_fetch_api){
				return;
			}
			let data = {
				id: r.id
			};
			r._busy_fetch_api = true;
			try {
				await this.$api.post('advertisers/fetchAPI', data);
				r.api_processing = true;
				// r.last_fetch_api = resp.entity.last_fetch_api;
				// r.api_num_offers = resp.entity.api_num_offers;
				// this.$ovNotify.success('Got ' + resp.entity.api_num_offers + ' offers');

			} catch (e) {
				console.error(e);
			}
			r._busy_fetch_api = false;
		},

		async loadData(){
			this.busy = true;
			let params = {
				page: this.paginate.page,
				limit: this.paginate.limit,
				keyword: this.filters.keyword,
			};
			try {
				let resp = await this.$api.get('/advertisers/getList', {params});
				this.records = resp.records;
				this.paginate.total = resp.total;
				this.paginate.numPages = Math.max(Math.ceil(this.paginate.total / this.paginate.limit), 1);
			} catch (e){
				console.error(e);
			}
			this.busy = false;
		}
	},
	created(){
		this.loadData();
	}

}
</script>
